/**
 * Chart view mode types — shared across UI, renderer, and persistence layers.
 * Single source of truth for view switching system.
 */

/** Mutually exclusive full-screen chart views */
export type ChartViewMode = 'chakra' | 'horaClock' | 'rashiChakra';

/** SVG group class names for non-default (special) views */
export const SPECIAL_VIEW_GROUPS: string[] = ['hora-clock-group', 'rashi-chakra-group'];
